import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'POST_DETAIL',
        create: 'POST_CREATE',
        update: 'POST_UPDATE'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'post_name',
        default: '',
        label: '岗位名称',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.post_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "post_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'post_code',
        default: '',
        label: '岗位编码',
        rule: {
          required: true,
          message: '必填',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.post_code,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "post_code", $$v);
              }
            }
          });
        }
      }, {
        prop: 'post_sort',
        default: this.$env.VUE_APP_FORM_SORT_MIN,
        label: '显示顺序',
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "min": _this.$env.VUE_APP_FORM_SORT_MIN
            },
            "model": {
              value: _this.form.model.post_sort,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "post_sort", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: this.$env.VUE_APP_DICT_STATUS_ACTIVE,
        label: '状态',
        render: function render() {
          return h("d2-dict-radio", {
            "attrs": {
              "name": "status",
              "button": true
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }, {
        prop: 'remark',
        default: '',
        label: '备注',
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.remark,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "remark", $$v);
              }
            }
          });
        }
      }];
    }
  }
};